export default {
  category: null,
  categories: null,
};
